<app-dropdown [close]="close" class="filter-dropdown" panelClass="filter-dropdown-panel" *ngIf="generalSettingsData && !loadingState"
  (showDropdown)="closeOpenFilterMobileDropdown(true)" (closeDropdown)="closeOpenFilterMobileDropdown(false)">
  <button
    app-dropdown-trigger
    class="no-style filter-btn"
    [matTooltip]="tooltipString"
    [matTooltipDisabled]="!showTooltip"
  >
    <span class="filter-value">
      <span class="filter-value-string">
        <span *ngIf="valueLabel" class="value-label">{{ valueLabel }}</span>
        {{ currentValueString }}
      </span>
    </span>
    <mat-icon matPrefix [svgIcon]="'show-more'" class="square-icon filter-icon"></mat-icon>
  </button>
  <ng-container app-dropdown-content>
    <div class="dropdown-list">
      <ng-container *ngFor="let item of filterItems">
        <button
          *ngIf="multi || !item.checked"
          class="dropdown-item"
          [ngClass]="{ active: item.checked }"
          (click)="toggleValue(item)"
          [disabled]="disabled"
        >
          {{ item.label }}
        </button>
      </ng-container>
    </div>
    <div class="mobile-content">
      <div class="filters-form">
        <label *ngIf="filterTitle" class="filters-title">{{ filterTitle }}</label>

        <mat-radio-group *ngIf="!multi" class="filters-list" [formControl]="formControl">
          <mat-radio-button *ngFor="let item of filterItems" [value]="item.value" [disabled]="disabled">
            {{ item.label }}
          </mat-radio-button>
        </mat-radio-group>

        <div *ngIf="multi" class="filters-list">
          <mat-checkbox
            *ngFor="let item of filterMultiItems"
            class="filters-list-item radio-view"
            [ngStyle]="{'--control-color': FiltersColorHelper.getStyleColor(item.color)}"
            [(ngModel)]="item.checked"
          >
            {{ item.label }}
          </mat-checkbox>
        </div>
      </div>
      <div class="btn-box">
        <button mat-flat-button color="primary" class="btn-md submit-filter" (click)="saveValue(formControl.value)" [disabled]="disabled">
          {{generalSettingsData.filterSearchMobileButtonText}}
        </button>
      </div>
    </div>
  </ng-container>
</app-dropdown>

<app-skeleton *ngIf="loadingState" [height]="48"/>